var _templateObject;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { Box } from '@creditas-ui/layout';
import { selectTheme } from '@creditas-ui/utilities';
import { styled } from '@creditas-ui/system';
var InputHint = styled(Box.withComponent('span', process.env.NODE_ENV === "production" ? {
  target: "e1levtf60"
} : {
  target: "e1levtf60",
  label: "InputHint"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", "px;\n"])), selectTheme('radio.hint.margin'), selectTheme('radio.hint.color'), selectTheme('radio.hint.fontSize'), selectTheme('radio.hint.fontWeight'), selectTheme('radio.hint.lineHeight'), selectTheme('radio.hint.letterSpacing'));
export { InputHint };